import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { BootstrapDialog, BootstrapDialogTitle } from "../common/BootstrapDialog";
import EditDocumentForm from "./EditDocumentForm";
import ButtonUI from "../material-ui/ButtonUI";
import editDocument from "../../api/editDocument";
import { AuthContext } from "../../context/Auth/AuthContext";
import getAllFieldTypeList from "../../api/getAllFieldTypeList";
import { EditActionButton } from "../common/ActionIconButton";
import EditIcon from "@mui/icons-material/Edit";

const editDocumentFormSchema = yup.object().shape({
  document_name: yup.string().required("Document name is required field"),
  // document_desc: yup
  //   .string()
  //   .required("Document Description is required field"),
  //category: yup.string().nullable().required("Category is required field"),
  subcategory: yup.string().required("Sub Category is required field"),
  //document_status: yup.string().required("Status is required field"),
});

const EditDocumentPopup = ({
  setDocumentUpdatedToTrue,
  tableValues,
  //categoryOptions,
  // subCategoryOptions,
  clientNames,
}) => {
  const [open, setOpen] = useState(false);
  const { token, user_id } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editDocumentFormSchema),
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onEditDocumentFormSubmit = async (editDocumentFormData) => {
    setLoading(true);
    const editDocumentFormResponse = await editDocument({
      token: token,
      user_id: user_id,
      document_id: tableValues.document_id,
      document_name: editDocumentFormData.document_name,
      document_desc: editDocumentFormData.document_desc,
      //category: tableValues.category_id,
      document_sub_category: editDocumentFormData.subcategory,
      //status: editDocumentFormData.document_status,
    });

    if (editDocumentFormResponse.code === 200) {
      setLoading(false);
      setDocumentUpdatedToTrue();
      setOpen(false);

      showSuccess("Document is updated successfully");
    } else {
      setLoading(false);
      showError("Error while updating document");
    }
  };

  const fetchSubCategory = async () => {
    try {
      const response = await getAllFieldTypeList({
        token,
        type: "document_subtype",
      });

      // make sure we always store an array
      const list = Array.isArray(response?.data) ? response.data : [];
      setSubCategoryOptions(list);
    } catch (error) {
      console.error("Error fetching sub categories:", error);
      setSubCategoryOptions([]); // keep it safe
    }
  };
  useEffect(() => {
    if (!open) return; // only when dialog is opened
    if (subCategoryOptions.length) return; // optional: avoid refetching
    fetchSubCategory();
  }, [open]); // or [open, subCategoryOptions.length]

  return (
    <div className="dialog-modal">
      <EditActionButton onClick={handleClickOpen} />
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        className="custom-edit-modal"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          className="edit-doc-modal"
          onClose={handleClose}
        >
          <div className="popup-header-svg-icon">
            <EditIcon />
          </div>
          <div className="popup-header-title">Edit Document</div>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <EditDocumentForm
            register={register}
            control={control}
            errors={errors}
            tableValues={tableValues}
            //categoryOptions={categoryOptions}
            subCategoryOptions={subCategoryOptions}
          />
        </DialogContent>
        <DialogActions sx={{ paddingBottom: "15px !important" }}>
          <div className="popup_submit_btn">
            <ButtonUI
              loading={loading}
              variant="contained"
              buttonText="Submit"
              style={{
                width: "150px",
                height: "35px",
                backgroundColor: "#1a6b7c",
                boxShadow: "none",
                border: "1px solid #1a6b7c",
                fontWeight: "500",
                borderRadius: "4px",
                letterSpacing: "0.07rem",
                marginTop: "20px",
              }}
              handleSubmit={handleSubmit}
              onFormSubmit={onEditDocumentFormSubmit}
            />
          </div>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default EditDocumentPopup;
